import {EAutopaymentError} from '../BalanceReplenishment';
import {EApproveStatus} from '../MessageMatchers/definitions';
import {EActionNews} from './ActionNews/definitions';
import {ESpecialOffer} from './SpecialOffers/definitions';
import {
  EAutopaymentNotificationStatus,
  EPayKeeperNotificationStatus,
  ESystemNewsType,
  ESystemNotificationType,
  EWebNotificationType,
} from './model';

export default {
  button: {
    downloadErrorFile: 'Скачать файл с ошибкой',
    toAudienceSection: 'В раздел аудитории',
    contactTechnicalSupport: 'Свяжитесь с техподдержкой',
    toReportBroadcast: 'В отчет рассылки',
    toChannel: 'В канал',
  },
  actionRequired: 'Требуется действие',
  hideActionTitle: 'Скрыть уведомление навсегда?',
  hideActionSubtitle:
    'Вы больше не увидите это уведомление и ссылку на инструкцию здесь, но информация останется доступной в документации',
  actionNews: {
    [EActionNews.FILL_DETAILS_REMINDER]: {
      title: 'Заполните реквизиты компании',
      description:
        'Вы не сможете зарегистрировать канал и отправлять сообщения пока не заполнены реквизиты вашей компании в Профиле компании.',
      fill: 'Заполнить реквизиты',
      modalTitle: 'Реквизиты компании',
    },
    [EActionNews.ACCEPT_TARIFFS_REMINDER]: {
      title: 'Примите ваши тарифы',
      descriptionContract:
        'Ознакомьтесь с тарифами и нажмите кнопку “Хорошо!”. После принятия тарифы станут доступными для регистрации каналов.',
      descriptionDefault:
        'Ознакомьтесь с тарифами и нажмите кнопку “Принять”. После принятия тарифы станут доступными для регистрации каналов.',
      check: 'Проверить тарифы',
    },
    [EActionNews.ACCEPT_MM_API_REMINDER]: {
      title: 'Примите условия использования Marketing Messages API (MM API)',
      description:
        'Вы ещё не приняли условия использования Marketing Messages API (MM API). Сейчас ваши рассылки в WhatsApp отправляются только через Cloud API, где сообщения стоят дороже.',
      acceptApi: 'Примите условия MM API, чтобы:',
      acceptReasons: ['отправлять сообщения более эффективно', 'повысить конверсию своих рассылок'],
      more: 'Подробнее об MM API',
      accept: 'Принять условия в Facebook',
    },
    [EActionNews.MAX_BOT_CONNECTION_PROMO]: {
      title: 'Подключайте <0></0>',
      description:
        'Пополняйте аудиторию сейчас и отправляйте коммуникации в самом стабильном канале - 85+ млн человек уже там!\n' +
        'Берем на себя регистрацию бизнеса в MAX. Старт работы в пару кликов.',
      button: 'Подключить MAX',
    },
    [EActionNews.DIALOGS_PROMO]: {
      title: 'Диалоги',
      description:
        'Вся история общения с получателями в одном месте: рассылки, сценарии, API, ваши сообщения и ответы на них',
      button: 'Перейти в Диалоги',
    },
  },
  news: {
    [ESystemNewsType.UpdatePlanned]: {
      title: 'Обновление {{date}}',
      content:
        '<0></0> будет обновление edna Pulse. Мы рекомендуем не планировать и не отправлять рассылки с {{startTime}} до {{endTime}}, так как в работе программы возможны кратковременные перебои.\n' +
        'Мы стараемся быть лучше для вас! Надеемся, вам понравится обновление.',
    },
    [ESystemNewsType.WhatsAppLicensePriceUpdatePlanned]: {
      title: 'Изменение стоимости лицензии WhatsApp',
      content:
        'С <0>1 апреля</0> повышается стоимость вашей лицензии WhatsApp Business API. С новой стоимостью вы можете ознакомиться в разделе <1>Профиль -> Профиль Компании -> Тарифы</1>. Учитывайте это при оплате лицензии за апрель, чтобы продолжать пользоваться сервисом.' +
        '<br/><br/>Мы не повышали цены на WhatsApp Business API почти 2 года, но больше не можем бороться с возросшими затратами. В связи со значительным ростом расходов на закупку нового инфраструктурного оборудования, поддержку текущего оборудования, оплату высококвалифицированных ИТ-специалистов и существующей инфляцией на другие компоненты нашей работы, мы вынуждены поднять стоимость лицензии. Кроме этого в edna Pulse были проведены глобальные доработки, которые позволят работать с сервисом ещё лучше.' +
        '<br/>При возникновении вопросов обратитесь к вашему менеджеру edna.',
    },
    [ESystemNewsType.MessageMatcherPresetSuggestion]: {
      title_one: 'Ваш канал зарегистрирован',
      title_few: 'Ваши каналы зарегистрированы',
      title_many: 'Ваши каналы зарегистрированы',
      content_one:
        '<0>Канал {{channels}}</0> зарегистрирован в Facebook! Давайте подберем для него шаблоны!',
      content_few:
        '<0>Каналы {{channels}}</0> зарегистрированы в Facebook! Давайте подберем для них шаблоны!',
      content_many:
        '<0>Каналы {{channels}}</0> зарегистрированы в Facebook! Давайте подберем для них шаблоны!',
      action: 'Подобрать шаблоны',
    },
  },
  system: {
    [ESystemNotificationType.UpdateRunning]:
      '{{date}} с {{startTime}} до {{endTime}} <0>мы обновляем edna Pulse</0>. В это время возможны кратковременные перебои в работе системы.',
    [ESystemNotificationType.MaintenanceRunning]:
      'В работе edna Pulse наблюдаются кратковременные перебои. Мы уже работаем над их устранением!',
    [ESystemNotificationType.TemporaryProblem]:
      'При отправке сообщений WhatsApp с вложениями через API может наблюдаться ошибка media-download-error. Она происходит, когда WhatsApp не может скачать вложение с вашего сервера. Мы работаем с WhatsApp над устранением проблемы.',
  },
  toUploads: 'В загрузки',
  toNotifications: 'В уведомления',
  web: {
    [EWebNotificationType.SubscribersUploadFailed]: `Список аудитории не загружен.`,
    [EWebNotificationType.SubscribersUploadPartial]: `Список аудитории загружен частично.`,
    [EWebNotificationType.SubscribersUploadSuccess]: `Список аудитории загружен.`,
    [EWebNotificationType.BroadcastCompleted]: `Рассылка "{{name}}" завершена.`,
    [EWebNotificationType.BroadcastCancelled]: `Рассылка "{{name}}" остановлена.`,
    [EWebNotificationType.LicenseExpiring]:
      'Ваша лицензия в edna Pulse истекает {{date}}. Чтобы продлить действие лицензии, оплатите стоимость услуг.',
    [EWebNotificationType.CallbackUpdated]: `URL-адрес вебхука успешно изменён.`,
    [EWebNotificationType.ApikeyUserUpdated]: `API-ключ успешно изменен.`,
    [EWebNotificationType.CompanyDetailsUpdated]: `Пользователь "{{login}}" поменял реквизиты компании.`,
    [EWebNotificationType.PaymentDetailsUpdated]: `Пользователь "{{login}}" поменял платежные реквизиты компании.`,
    [EWebNotificationType.TenantTariffAccepted]: `Пользователь "{{login}}" согласился с доступными тарифами.`,
    [EWebNotificationType.JivoEnabled]:
      'Пользователь "{{login}}" подключил весь трафик канала WhatsApp к чат-платформе Jivo.',
    [EWebNotificationType.JivoDisabled]:
      'Пользователь "{{login}}" отключил весь трафик канала WhatsApp от чат-платформы Jivo.',
    [EWebNotificationType.MessageMatcherStatusChanged]: {
      [EApproveStatus.DISABLED]:
        'Шаблон "{{name}}" был отключен. Все запланированные рассылки, в которых используется данный шаблон, будут остановлены.',
      [EApproveStatus.PAUSED]:
        'Шаблон "{{name}}" был остановлен. Все запланированные рассылки, в которых используется данный шаблон, будут остановлены.',
      [EApproveStatus.APPROVED]: 'У шаблона "{{name}}" изменился статус. Новый статус: Активный.',
      [EApproveStatus.REJECTED]: 'У шаблона "{{name}}" изменился статус. Новый статус: Отклонен.',
      [EApproveStatus.PENDING]: 'У шаблона "{{name}}" изменился статус. Новый статус: Регистрация.',
      [EApproveStatus.NOT_SENT]: 'У шаблона "{{name}}" изменился статус. Новый статус: Черновик.',
      [EApproveStatus.ARCHIVED]: 'У шаблона "{{name}}" изменился статус. Новый статус: В архиве.',
    },
    [EWebNotificationType.MessageMatcherCategoryChanged]: `Категория шаблона WhatsApp "{{name}}" была изменена на стороне WhatsApp. Новая категория шаблона: "{{newCategory}}".`,
    [EWebNotificationType.InvoicePaid]: 'Успех! Баланс пополнен.',
    [EWebNotificationType.PaykeeperPayment]: {
      [EPayKeeperNotificationStatus.PAYMENT_FAIL]: 'Не удалось зачислить ваш платеж от {{date}}.',
      [EPayKeeperNotificationStatus.PAYMENT_SUCCESS]:
        'Ваш платеж на {{sum}} руб. от {{date}} успешно зачислен.',
      [EPayKeeperNotificationStatus.REFUND_SUCCESS]:
        'Возврат платежа по карте от {{date}} {{login}} выполнен.',
      [EPayKeeperNotificationStatus.RECURRENT_PAYMENT_SUCCESS]: 'Автоплатеж зачислен.',
      [EPayKeeperNotificationStatus.RECURRENT_PAYMENT_FAIL]:
        'Не удалось списать автоплатеж с карты.',
      [EPayKeeperNotificationStatus.RECURRENT_CARD_BINDING_CREATED]: 'Автоплатеж настроен.',
    },
    [EWebNotificationType.ChannelProfilePartnerProfileCreated]:
      'Выберите тариф канала для WhatsApp-аккаунта "{{name}}", чтобы завершить регистрацию.',
    [EWebNotificationType.ChannelProfileQualityScoreChanged]:
      'WhatsApp Business API {{name}}: изменилось качество. Новое качество: {{qualityScore}}.',
    [EWebNotificationType.ChannelProfileMessagingLimitChanged]:
      'WhatsApp Business API {{name}}: изменился лимит. Новый лимит: {{messagingLimit}}.',
    [EWebNotificationType.ChannelProfileQualityStatusChanged]:
      'У WhatsApp-аккаунта {{name}} изменился статус. Новый статус: {{qualityStatus}}.',
    [EWebNotificationType.ChannelProfileWABAViolation]:
      'Бизнес-аккаунт WhatsApp {{wabaId}} нарушает правила или политику использования WhatsApp. Причина — {{violationType}}. Есть риск ограничения или отключения следующих каналов: {{channels}}. Рекомендуем <0>следовать рекомендациям</0>.',
    [EWebNotificationType.ChannelProfileWABARestriction]:
      'Бизнес-аккаунт WhatsApp {{wabaId}} ограничен из-за нарушения правил или политики использования WhatsApp. Следующие каналы ограничены до {{expirationDate}} и могут только принимать входящие сообщения: {{channels}}. Чтобы подать апелляцию, <0>следуйте рекомендациям</0>.',
    [EWebNotificationType.ChannelProfileWABADisable]:
      'Бизнес-аккаунт WhatsApp {{wabaId}} отключен из-за нарушения правил или политики использования WhatsApp. Работа следующих каналов остановлена: {{channels}}. Регистрация новых каналов в этом бизнес-аккаунте WhatsApp недоступна. Чтобы подать апелляцию, <0>следуйте рекомендациям</0>.',
    [EWebNotificationType.ChannelProfileWABAReinstate]:
      'Бизнес-аккаунт WhatsApp {{wabaId}} восстановлен. Следующие каналы снова активны: {{channels}}.',
    [EWebNotificationType.ChannelProfileWABAMarketingMessagesApiTermsSigned]: {
      title_one: 'Вы успешно приняли условия использования MM API для канала {{channels}}.',
      title_few: 'Вы успешно приняли условия использования MM API для каналов {{channels}}.',
      title_many: 'Вы успешно приняли условия использования MM API для каналов {{channels}}.',
    },
    [EWebNotificationType.StripeCheckout]: {
      [EAutopaymentError.GENERIC_DECLINE]:
        'Не удалось выполнить автоплатеж {{date}}. Для получения дополнительной информации обратитесь в службу технической поддержки <0>{{email}}</0>.',
      [EAutopaymentError.AUTHENTICATION_REQUIRED]:
        'Не удалось выполнить автоплатеж {{date}}. Ваш банк запросил подтверждение платежа.',
      [EAutopaymentError.CARD_DECLINE]:
        'Не удалось выполнить автоплатеж с помощью привязанной карты.',
      [EAutopaymentError.INSUFFICIENT_FUNDS]:
        'Не удалось выполнить списание {{date}}. Недостаточно средств на карте.',
      [EAutopaymentNotificationStatus.AUTO_REPLENISHMENT_ENABLED]: 'Автоплатеж подключен.',
      [EAutopaymentNotificationStatus.AUTO_REPLENISHMENT_DISABLED]: 'Автоплатеж отключен.',
      [EAutopaymentNotificationStatus.PAYMENT_SUCCEEDED]:
        'Автоплатеж подключен. Для получения чека об оплате перейдите по ссылке на <0>сайт платежной системы Stripe</0>.',
    },
    [EWebNotificationType.MessageReportSuccess]: 'Отчет {{name}} сформирован.',
    [EWebNotificationType.MessageReportFailed]: 'Формирование отчета {{name}} прервано.',
    [EWebNotificationType.FlowMessageReportSuccess]: 'Отчет {{name}} сформирован.',
    [EWebNotificationType.FlowMessageReportFailed]: 'Формирование отчета {{name}} прервано.',
    [EWebNotificationType.ChannelProfileMaxBotRegistration]:
      'Канал "{{name}}" отправлен на регистрацию.',
    [EWebNotificationType.ChannelProfileMaxBotSubjectCreated]: 'Канал "{{name}}" зарегистрирован.',
    [EWebNotificationType.ChannelProfileMaxConnected]: 'Канал "{{name}}" подключен.',
    [EWebNotificationType.ChannelProfileMaxDisconnected]: 'Канал "{{name}}" отключен.',
    [EWebNotificationType.ChannelProfileTelegramConnected]: 'Канал "{{name}}" подключен.',
    [EWebNotificationType.ChannelProfileTelegramDisconnected]: 'Канал "{{name}}" отключен.',
  },
  specialOffers: {
    connect: 'Подключить',
    offer: {
      [ESpecialOffer.SMS]: {
        title: 'СМС-рассылки для бизнеса — классический канал связи с клиентами по хорошим ценам!',
      },
      [ESpecialOffer.FLOW]: {
        title:
          'Конструктор чат-бота WhatsApp для диалогов и рассылок. Разгрузите ваших сотрудников и сделайте ваши рассылки интерактивными.',
      },
    },
    mail: {
      [ESpecialOffer.SMS]: {
        subject: 'Запрос информации о возможностях канала СМС от {{login}}, {{companyName}}',
        body: 'Добрый день!\r\nЯ хочу узнать больше о возможностях канала СМС.',
      },
      [ESpecialOffer.FLOW]: {
        subject:
          'Запрос информации о возможностях и преимуществах Сценариев от {{login}}, {{companyName}}',
        body: 'Добрый день!\r\nЯ хочу узнать больше о возможностях и преимуществах Сценариев.',
      },
    },
  },
};
